import { useQuery } from "react-query";
import { searchScorecard } from "../../../../../actions/CarrierAgreementMgmt/ScoreCard";

const useGetScorecardReportDaily = (searchInputsData) => {
  return useQuery(
    ["GetScorecarReportDaily", searchInputsData],
    () => searchScorecard(searchInputsData),
    {
      refetchOnWindowFocus: false,
    }
  );
};
export default useGetScorecardReportDaily;
